import React from 'react';
import { Formik, useFormik, Form } from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/common/dropdown/Dropdown';
import Datepicker from '../../components/common/datePicker/DatePicker';
import CustomEditor from '../../components/common/customEditor/CustomEditor';
import DropZone from '../../components/common/dropzone/DropZone';
import Icon from '../../assets/images/Icon (4).svg';
import Icon2 from '../../assets/images/Icon (5).svg';
import { InputField } from 'components/common';
import apiService from 'services/apiService';
import SignatureModal from 'components/common/signatureModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const identityType = [
  { label: 'Full Time', value: 'full_time' },
  { label: 'Part Time', value: 'part_time' },
];

const ContractForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [apiData, setApiData] = React.useState(false);

  const [res, setRes] = React.useState();

  const [isToggledModal, setIsToggledModal] = React.useState(false);

  const saveddata = JSON.parse(localStorage.getItem('rowOriginalData'));

  console.log('saveddatasaveddata', saveddata);

  const user = JSON.parse(localStorage.getItem('user'));

  const userData = saveddata?.applications?.some(
    (item) => item.user_id == user.id
  );

  const storedData = JSON.parse(localStorage.getItem('draftData'));

  const [finalFile, setFinalFile] = React.useState(null);

  const [isToggled, setIsToggled] = React.useState(false);

  const errorRef = React.useRef('');

  const [formData, setFormData] = React.useState({
    contractType: '',
    duration: '',
    heading: '',
    uploadContract: [],
    draftContract: '',
    isToggled: false, // Example for the conditional validation on heading
  });

  const [errors, setErrors] = React.useState({});

  const validateContracts = (formData) => {
    const errors = {};

    // 1. Contract Type Validation
    if (!formData.contractType) {
      errors.contractType = 'Contract Type is required';
    }

    // 2. Duration Validation
    if (!formData.duration || formData.duration < 1) {
      errors.duration = 'Duration must be at least 1';
    }

    // 3. Heading Validation (conditional on `isToggled`)
    if (formData.isToggled && !formData.heading) {
      errors.heading = 'Contract Title is required';
    }

    // 4. uploadContract Validation
    if (formData.uploadContract && formData.uploadContract.length === 0) {
      // If uploadContract is empty, check draftContract
      if (!formData.draftContract || formData.draftContract.trim() === '') {
        errors.uploadContract =
          'Please upload a contract or provide a draft contract';
      }
    }

    // 5. draftContract Validation (conditional on `uploadContract`)
    if (!formData.uploadContract || formData.uploadContract.length === 0) {
      if (!formData.draftContract || formData.draftContract.trim() === '') {
        errors.draftContract =
          'Draft contract is required if no contract is uploaded';
      }
    }

    return errors;
  };

  const toggleState = () => {
    setIsToggled((prevState) => !prevState);
  };

  const fetchRequests = async (id) => {
    try {
      const response = await apiService.get(`announced-jobs/${id}`);
      if (response?.code === 200) {
        setRes(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const uploadFile = async (payload) => {
    try {
      setLoading(true);
      const formDataFile = new FormData();
      formDataFile.append('project', 'visitingdoctor');
      formDataFile.append('files', payload.upload_contract[0]);
      const response = await axios.post(
        'https://micro-helper.ascend.com.sa/minio/uploads',
        formDataFile,
        {
          headers: {
            Accept: '*/*',
          },
        }
      );
      {
        apiData &&
          createDraft({ ...payload, upload_contract: response?.data?.paths });
      }
    } catch (error) {
      setLoading(false);
      toast.error('Error Uploading File');
    }
  };

  const createDraft = (load) => {
    setLoading(true);
    apiService
      .post(`contracts/create`, load)
      .then((res) => {
        toast.success('Contract Created Successfully!');
        navigate('/Detail');
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || 'Something Went Worng');
      });
    setLoading(false);
  };

  React.useEffect(() => {
    fetchRequests(saveddata?._id);
  }, []);

  const saveSignature = (file) => {
    setIsToggledModal(false);
    setFinalFile(file);
  };

  const validationSchema = Yup.object({
    contractType: Yup.string().required('Contract Type is required'),
    duration: Yup.number()
      .min(1, 'Duration must be at least 1')
      .required('Duration is required'),
    heading: Yup.string().test(
      'is-heading-required',
      'Contract Title is required',
      function (value) {
        const { isToggled } = this.parent; // Accessing the parent context (i.e., the form data)
        if (isToggled && !value) {
          return false; // Validation fails if 'isToggled' is true and 'heading' is empty
        }
        return true; // Otherwise, validation passes
      }
    ),
    uploadContract: Yup.array()

      .test(
        'upload-or-draft',
        'Please upload a contract or provide a draft contract',
        function (value) {
          const { draftContract } = this.parent;

          console.log('uploadContract value:', value);
          console.log('draftContract value:', draftContract);
          // Ensure draftContract is treated as a valid string
          const isDraftValid =
            typeof draftContract === 'string' && draftContract.trim() !== '';
          console.log(
            'isDraftValid value:',
            !isDraftValid != '',
            (!value || value.length === 0) && !isDraftValid
          );
          if (
            (value == null ||
              ((Array.isArray(value) || typeof value === 'string') &&
                value.length === 0)) &&
            !isDraftValid
          ) {
            return this.createError({
              message: 'Please upload a contract or provide a draft contract',
            });
          }

          return true;
        }
      ),
    draftContract: Yup.string().test(
      'draft-or-upload',
      'Draft contract is required if no contract is uploaded',
      function (value) {
        const { uploadContract } = this.parent;
        if ((!uploadContract || uploadContract.length === 0) && !value) {
          return this.createError({
            message: 'Draft contract is required if no contract is uploaded',
          });
        }
        return true;
      }
    ),
  });

  const handlesubmitForm = (values, e) => {
    const payload = {
      contract_type:
        values?.contractType == 'Full Time' ? 'full_time' : 'part_time',
      hourly_fees: values?.duration,
      start_date: values?.startDate,
      end_date: values?.endDate,
      draft_contract: values?.draftContract,
      upload_contract: values?.uploadContract ? values.uploadContract : null,
      title: values?.heading,
      signature: finalFile ? finalFile : '',
      announced_job_application_id: storedData?._id,
      announced_job_id: storedData?.announced_job_id,
      physician_id: storedData?.user?.physician?._id,
      job_request_id: saveddata?.job_position?.job_request_id,
    };

    if (values?.uploadContract?.length > 0) {
      uploadFile(payload);
      return;
    }

    {
      apiData && createDraft(payload);
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {isToggledModal && (
        <SignatureModal
          setFinalFile={saveSignature}
          setIsToggledModal={setIsToggledModal}
        />
      )}
      <Formik
        initialValues={{
          contractType: '',
          duration: '0',
          startDate: saveddata?.created_at || '',
          endDate: saveddata?.till || '',
          draftContract: '',
          uploadContract: [],
          signature: finalFile ? finalFile : '',
          heading: '',
        }}
        validationSchema={validationSchema}
        onSubmit={handlesubmitForm}
      >
        {({
          values,
          handleChange,
          setFieldValue,
          errors,
          touched,
          handleSubmit,
        }) => (
          <Form className="space-y-6">
            <div className="flex items-center justify-between">
              <div className="text-gray-600 flex items-center">
                <span>
                  <img src={Icon} alt="logo" />
                </span>
                <span className="text-sm pl-2">Draft Contract</span>
                <span className="pl-2"> &gt; </span>
                <span className="pl-2">
                  <img src={Icon2} alt="logo" />
                </span>
                <span className="pl-2 cursor-pointer" onClick={toggleState}>
                  {'Review Contract'}
                </span>
              </div>
              {!isToggled && (
                <>
                  <button
                    onClick={toggleState}
                    className="text-white bg-[#007A63] flex justify-center items-center focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5"
                  >
                    Next
                  </button>
                </>
              )}
              {isToggled && (
                <div className="flex justify-between gap-2 item-center w-[24%]">
                  <button
                    onClick={() => {
                      setIsToggledModal((prev) => !prev);
                    }}
                    className="border-customGreen border-solid border-[2px] bg-[#EFFAF6]     
                                         flex justify-center items-center focus:ring-4 w-[160px] h-[40px] 
                                         font-medium rounded-lg text-sm"
                  >
                    <div className="mr-2">
                      <svg
                        width="17"
                        height="10"
                        viewBox="0 0 17 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6747 3.38065C15.3685 3.46815 13.4935 4.7619 12.5497 5.1869C11.9544 5.51753 11.3007 5.72977 10.6247 
                                                5.8119C10.0497 5.8119 9.96221 5.40565 10.081 4.4994C10.1122 4.2994 10.381 2.49315 8.99971 2.5744C8.37471 2.6119 7.37471
                                                 3.1994 4.71221 5.7619L5.76221 3.1244C5.93428 2.68783 5.96141 2.2075 5.83957 1.75433C5.71774 1.30117 5.45342 0.899192 5.08563
                                                  0.607763C4.71784 0.316333 4.26608 0.150897 3.79706 0.135886C3.32805 0.120874 2.86664 0.257083 2.48096 0.524397L1.08721 1.45565C0.997091 
                                                  1.51455 0.93357 1.60635 0.910215 1.71145C0.886859 1.81655 0.90552 1.92662 0.962213 2.01815L1.39971 2.6994C1.45862 2.78952
                                                   1.55042 2.85304 1.65552 2.8764C1.76062 2.89975 1.87068 2.88109 1.96221 2.8244L3.43096 1.8744C3.53216 1.81372 3.64972 1.78602 3.76736
                                                    1.79514C3.885 1.80425 3.99689 1.84973 4.08753 1.92526C4.17818 2.0008 4.24308 2.10266 4.27326 2.21672C4.30344 2.33079 4.29739 2.45142
                                                     4.25596 2.5619L1.75596 8.8119C1.689 8.98487 1.68323 9.17554 1.73961 9.35224C1.796 9.52894 1.91115 9.68103 2.06592 9.78324C2.2207 9.88545 
                                                     2.40579 9.93163 2.59044 9.91411C2.77509 9.89658 2.94818 9.8164 3.08096 9.6869C4.14971 8.61815 6.99971 5.86815 8.42471 4.73065C8.35633
                                                      5.10083 8.3678 5.48134 8.45834 5.84673C8.54888 6.21213 8.7164 6.55397 8.94971 6.8494C9.16488 7.06617 9.42412 7.23416 9.70988 7.34199C9.99563 
                                                      7.44983 10.3012 7.49498 10.606 7.4744C11.5124 7.40888 12.3944 7.15108 13.1935 6.71815C14.031 6.34315 15.6935 5.13065 16.6997 5.0494C16.8031 
                                                      5.04463 16.9008 5.00058 16.9728 4.92624C17.0448 4.85191 17.0857 4.75289 17.0872 4.6494V3.8369C17.0944 3.77897 17.089 3.72018 17.0715
                                                       3.66452C17.0539 3.60886 17.0246 3.55763 16.9854 3.51434C16.9463 3.47104 16.8983 3.43669 16.8446 3.41362C16.791 3.39055 16.7331 3.3793 16.6747 
                                                       3.38065Z"
                          fill="#2D9F75"
                        />
                      </svg>
                    </div>
                    <span className="text-[#007A63]">
                      {finalFile == null ? 'Add Signature' : 'Edit Signature'}
                    </span>
                  </button>

                  <button
                    disabled={finalFile == null || values.heading == ''}
                    onClick={(e) => {
                      e.preventDefault();

                      setApiData(true);
                      handleSubmit(); // This will trigger Formik's submit handler
                    }}
                    className=" flex justify-center items-center focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5"
                    style={{
                      backgroundColor:
                        finalFile == null || values.heading == ''
                          ? 'transparent'
                          : '#007A63',
                      color:
                        finalFile == null || values.heading == ''
                          ? '#CDD0D5'
                          : 'white',
                    }}
                  >
                    <>Submit</>
                  </button>
                </div>
              )}
            </div>

            {/* Form Header */}
            <div className="bg-white shadow-md rounded-lg p-6">
              <div className="rounded-lg p-6 ">
                <div className="pb-4">
                  <div className="flex justify-between mb-4">
                    {isToggled && (
                      <div>
                        <InputField
                          name="heading"
                          onChange={(e) => {
                            setFieldValue('heading', e.target.value);
                          }}
                          type="text"
                          className="text-lg font-semibold border-2 border-white rounded-md p-2 w-[30%] focus:outline-none focus:ring"
                          placeholder="Write a Contact Title Here"
                          value={values?.heading}
                        />
                        {touched.heading && errors.heading && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.heading}
                          </div>
                        )}
                      </div>
                    )}
                    <span className="text-sm text-gray-500">
                      REF-{res?.jobNumber}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-4 gap-4  border-b">
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      Name
                    </label>
                    <p className="mt-1 text-gray-900 font-semibold">
                      {storedData?.user?.firstName} {storedData?.user?.lastName}
                    </p>
                  </div>
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      Specialty
                    </label>
                    <p className="bg-[#EEEBFF] text-[#2B1664] font-semibold whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-sm rounded">
                      {res?.medical_speciality?.name}{' '}
                    </p>
                  </div>
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      Level
                    </label>
                    <p className="bg-[#FDEBFF] text-[#620F6C] font-semibold whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-sm rounded">
                      {res?.speciality?.name}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#868C98]">
                      Hospital Name
                    </label>
                    <p className="mt-1 text-gray-900 font-semibold">
                      {res?.creator?.sites[0]?.name}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-4 gap-4 mt-4 border-b">
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      Region
                    </label>
                    <p className="mt-1 text-gray-900 font-semibold">
                      {res?.creator?.cluster?.name}
                    </p>
                  </div>
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      City
                    </label>
                    <p className="mt-1 text-gray-900 font-semibold">
                      {res?.creator?.region?.name}
                    </p>
                  </div>
                  <div className="border-r">
                    <label className="block text-sm font-medium text-[#868C98]">
                      Contact No
                    </label>
                    <p className="mt-1 text-gray-900 font-semibold">
                      {storedData?.user?.phoneNumber}
                    </p>
                  </div>
                </div>
                {isToggled && (
                  <div className="grid grid-cols-4 gap-4 mt-4 border-b">
                    <div className="border-r">
                      <label className="block text-sm font-medium text-[#868C98]">
                        Contract Type
                      </label>
                      <p className="mt-1 text-gray-900 font-semibold">
                        {values?.contractType}
                      </p>
                    </div>
                    <div className="border-r">
                      <label className="block text-sm font-medium text-[#868C98]">
                        Duration
                      </label>
                      <p className="mt-1 text-gray-900 font-semibold">
                        {values?.duration}
                      </p>
                    </div>
                    <div className="border-r">
                      <label className="block text-sm font-medium text-[#868C98]">
                        Start Date
                      </label>
                      <p className="mt-1 text-gray-900 font-semibold">
                        {values?.startDate}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-[#868C98]">
                        End Date
                      </label>
                      <p className="mt-1 text-red-500 font-semibold">
                        {values?.endDate}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {!isToggled && (
                <>
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                      <div>
                        <label className="block font-medium mb-1">
                          Contract Type *
                        </label>
                        <CustomSelect
                          zIndex={'9999'}
                          name="contractType"
                          onFieldSelect={(e) => {
                            setFieldValue('contractType', e?.label);
                          }}
                          value={values.contractType}
                          options={identityType}
                        />
                        {touched.contractType && errors.contractType && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.contractType}
                          </div>
                        )}
                      </div>

                      <div>
                        <label className="block font-medium mb-1">
                          Hourly Fee *
                        </label>
                        <InputField
                          type={'number'}
                          name="duration"
                          value={values.duration}
                          min="0"
                          onChange={(e) => {
                            setFieldValue('duration', e.target.value);
                          }}
                          className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                        />
                        {touched.duration && errors.duration && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.duration}
                          </div>
                        )}
                      </div>

                      <div>
                        <label className="block font-medium mb-1">
                          Start Date *
                        </label>
                        <Datepicker
                          disabled={true}
                          name="startDate"
                          onChange={(e) => setFieldValue('startDate', e)}
                          value={values.startDate}
                        />
                        {touched.startDate && errors.startDate && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.startDate}
                          </div>
                        )}
                      </div>

                      <div>
                        <label className="block font-medium mb-1">
                          End Date *
                        </label>
                        <Datepicker
                          disabled={true}
                          name="endDate"
                          onChange={(e) => setFieldValue('endDate', e)}
                          value={values.endDate}
                        />
                        {touched.endDate && errors.endDate && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.endDate}
                          </div>
                        )}
                      </div>
                    </div>

                    {!values.uploadContract.length ? (
                      <div className="w-full overflow-hidden pt-5">
                        <label className="block font-medium mb-1">
                          Draft Contract
                        </label>
                        <CustomEditor
                          title={false}
                          width={1530}
                          name="draftContract"
                          setValue={(e) => {
                            setFieldValue('draftContract', e); // Update Formik state
                            errorRef.current = '';
                          }}
                          value={values.draftContract}
                        />
                        {errors.draftContract && touched.draftContract && (
                          <div className="text-red-500 text-sm">
                            {errors.draftContract}
                          </div>
                        )}
                      </div>
                    ) : null}

                    {!values.uploadContract.length && !values.draftContract ? (
                      <div className="my-4 flex items-center justify-center space-x-4">
                        <div className="border-t border-gray-300 flex-grow"></div>
                        <span className="text-gray-500 text-sm">OR</span>
                        <div className="border-t border-gray-300 flex-grow"></div>
                      </div>
                    ) : null}

                    {!values.draftContract ? (
                      <>
                        <div>
                          <label className="block font-medium mb-1">
                            Upload Contract *
                          </label>
                          <DropZone
                            name="uploadContract"
                            onChange={(files) => {
                              setFieldValue('uploadContract', files);
                              errorRef.current = '';
                            }}
                            value={values.uploadContract}
                            condition={false}
                            height={'200px'}
                            multiple={false}
                          />

                          {errors.uploadContract && touched.uploadContract && (
                            <div className="text-red-500 text-sm">
                              {errors.uploadContract}
                            </div>
                          )}
                        </div>
                      </>
                    ) : null}
                  </>
                </>
              )}
              <div>
                {isToggled && (
                  <div
                    dangerouslySetInnerHTML={{ __html: values?.draftContract }}
                  />
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ContractForm;
